module.exports = __webpack_public_path__ + "img/ember_spirit.592fafb1.png";